/**
 * TKT #274563 · Custom Capacitor bridge for DIRECT native Google Sign-In.
 *
 * iOS     → AppAuth 2.1.0 (pinned) with prompt=select_account + PKCE + raw nonce,
 *           mirroring GoogleSignIn 9.2.0's request parameters (account chooser
 *           on every tap; GoogleSignIn 9.2.0 has no prompt control).
 * Android → Credential Manager button flow (GetSignInWithGoogleOption): pick or
 *           add an account; nonce-bearing Google ID token.
 *
 * The native nonce is passed VERBATIM (no SHA-256 transform): the pinned
 * GoogleSignIn-iOS 9.2.0 source forwards `options.nonce` straight into the
 * OIDAuthorizationRequest, and Credential Manager echoes `setNonce` as-is, so
 * the id_token `nonce` claim carries the raw server nonce on BOTH platforms.
 * (The SHA-256 convention is Firebase's, not the SDK's.)
 *
 * Native interface:
 *   signIn({ nonce, serverClientId }) -> { idToken }
 *     rejects "sign_in_cancelled" when the user closes the chooser (or signOut
 *     cancels it); other codes are genuine failures. filterByAuthorizedAccounts
 *     is ignored (button flow).
 *   signOut() -> void      // local only: no revocation, no browser-cookie clearing
 *   disconnect() -> void   // account deletion only (revokes the Google grant)
 */
import { registerPlugin } from "@capacitor/core";

export const CruiseGoogleAuth = registerPlugin("CruiseGoogleAuth");

// Web/server OAuth client ID (Android `serverClientId`; iOS also reads
// GIDServerClientID from Info.plist). Supplied at build time; never a secret.
export const GOOGLE_SERVER_CLIENT_ID = process.env.REACT_APP_GOOGLE_SERVER_CLIENT_ID || "";
